/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
'use client';

import { Checkbox, Group, Skeleton, Stack, Text, rem } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import { useGetProofOfWork } from '../../../features/booking/api/master-data/use-get-proof-of-work';
import type { RatingFormData } from './types';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export function ReasonSection() {
  const { control, watch } = useFormContext<RatingFormData>();
  const rating = watch('rating');

  const { orderDetails: order } = useBookingStore((state) => state);

  const { data: reasonList, isLoading: isLoadingReasons } = useGetProofOfWork(
    {
      reason_type: 'rating',
      user_type: 'user',
      service_id: order?.service._id || '',
      group_star: rating,
      delivery_type: order?.delivery_type || order?.service.delivery_type || '',
    },
    { enabled: !!order?.service._id }
  );

  return (
    <Stack
      gap={rem(16)}
      p={rem(16)}
      w="100%"
      mih={isLoadingReasons ? rem(300) : 'auto'}
    >
      <Text fz={rem(16)} fw={600} c="neutral.7">
        Bạn không hài lòng về điều gì?fdsaf
      </Text>

      <Stack gap={rem(8)}>
        {isLoadingReasons ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              key={index}
              height={24}
              width={`${100 - index * 30}%`}
              radius="md"
            />
          ))
        ) : (
          <Controller
            name="selectedReasons"
            control={control}
            render={({ field }) => (
              <Checkbox.Group
                value={field.value}
                onChange={field.onChange}
                styles={{
                  root: { gap: rem(20) },
                }}
              >
                <Group mt="xs">
                  {reasonList?.map((reason) => (
                    <Checkbox
                      key={reason._id}
                      label={reason.title_vi}
                      value={reason.code}
                      labelPosition="left"
                      w="100%"
                      styles={{
                        body: {
                          justifyContent: 'space-between',
                          cursor: 'pointer',
                        },
                        label: {
                          fontSize: rem(14),
                          lineHeight: rem(20),
                          fontWeight: 500,
                          color: 'neutral.7',
                        },
                      }}
                    />
                  ))}
                </Group>
              </Checkbox.Group>
            )}
          />
        )}
      </Stack>
    </Stack>
  );
}
